<template>
  <div class='animated fadeIn'>
    <b-row class='justify-content-md-center'>
      <b-col cols='12' lg='10'>
        <b-card class='shadow-sm bg-white rounded' border-variant='light'>
          <div>
            <el-button type='success' icon='el-icon-back' circle @click='goBack'></el-button>
          </div>
        </b-card>
        <b-card class='shadow-sm bg-white rounded' border-variant='light' header-bg-variant='secondary'>
          <b-list-group flush>
            <b-list-group-item>
                <b-row class='justify-content-md-center'>
                  <b-col sm='2'>
                    <b-img v-if='user.icon' :src='user.icon' width='128' height='128' rounded></b-img>
                    <!-- <b-img v-else src='../admin.png' width='128' height='128'></b-img> -->
                  </b-col>
                  <b-col sm='7'>
                    <croppa v-if='provider == false'
                      v-model='myCroppa'
                      :width='256'
                      :height='256'
                      :auto-sizing='true'
                      placeholder='プロフィール画像選択'
                      :placeholder-font-size='14'
                      :accept="'image/*'"></croppa>
                  </b-col>
                  <b-col sm='2'>
                    <b-button v-if='user.key' class='submit-btn' variant='danger' v-b-modal.modal-center>更新</b-button>
                    <b-button v-else class='submit-btn' variant='danger' v-b-modal.modal-center>登録</b-button>
                    <b-modal v-if="!user.enable" id='modal-center'
                            ref='modal'
                            title='無効化'
                            @ok='storeData'
                            centered
                            header-bg-variant='danger'
                            body-text-variant='danger'
                            ok-variant='danger'
                            size='sm'
                            class='px100-btn'
                          >
                      <p class='my-4 font-weight-bold' style="font-size:20px;">当該ユーザを無効にします</p>
                      <p class='my-4'>よろしいですか?</p>
                    </b-modal>
                    <b-modal v-else-if='user.key' id='modal-center'
                            ref='modal'
                            title='プロフィール'
                            @ok='storeData'
                            centered
                            header-bg-variant='danger'
                            body-text-variant='danger'
                            ok-variant='danger'
                            size='sm'
                            class='px100-btn'
                          >
                      <p class='my-4'>プロフィール情報を更新します</p>
                      <p class='my-4'>よろしいですか?</p>
                    </b-modal>
                    <b-modal v-else id='modal-center'
                            ref='modal'
                            title='プロフィール'
                            @ok='storeData'
                            centered
                            header-bg-variant='danger'
                            body-text-variant='danger'
                            ok-variant='danger'
                            size='sm'
                            class='px100-btn'
                          >
                      <p class='my-4'>プロフィール情報を登録します</p>
                      <p class='my-4'>よろしいですか?</p>
                    </b-modal>
                  </b-col>
                </b-row>
            </b-list-group-item>

            <b-list-group-item>
              <b-card-body>
                <b-row>
                  <b-col sm='3'><label for='input-none'>{{getTitle('name')}}:</label></b-col>
                  <b-col sm='9'><el-input size='medium' type='text' v-model='user.name' disabled></el-input></b-col>
                </b-row>
                <b-row>
                  <b-col sm='3'><label for='input-none'>{{getTitle('status')}}:</label></b-col>
                  <b-col sm='9'><el-input size='medium' type='text' v-model='user.status'></el-input></b-col>
                </b-row>
                <b-row>
                  <b-col sm='3'><label for='input-none'>{{getTitle('email')}}:</label></b-col>
                  <b-col sm='9'><el-input size='medium' type='text' v-model='user.email' disabled></el-input></b-col>
                </b-row>
                <b-row v-if="authUser && authUser.role == 'admin' || (authUser.role == 'owner' && user.role != 'admin')">
                  <b-col sm='3'><label for='input-none'>{{getTitle('role')}}:</label></b-col>
                  <b-col sm='9'>
                    <b-form-select v-if="authUser && authUser.role == 'admin'" v-model='selected' :options='adminOptions' class='mb-3' />
                    <b-form-select v-else-if="authUser && authUser.role == 'owner'" v-model='selected' :options='ownerOptions' class='mb-3' />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm='3'><label for='input-none'>{{getTitle('option')}}:</label></b-col>
                  <b-col sm='9'>
                    <b-list-group flush>
                      <b-list-group-item>姓 (漢字)
                        <el-input size='medium' type='text' v-model="user.option['name']['first']"></el-input>
                      </b-list-group-item>
                      <b-list-group-item>姓 (カナ)
                        <el-input size='medium' type='text' v-model="user.option['name']['first_kana']"></el-input>
                      </b-list-group-item>
                      <b-list-group-item>名 (漢字)
                        <el-input size='medium' type='text' v-model="user.option['name']['last']"></el-input>
                      </b-list-group-item>
                      <b-list-group-item>名 (カナ)
                        <el-input size='medium' type='text' v-model="user.option['name']['last_kana']"></el-input>
                      </b-list-group-item>
                      <b-list-group-item>生年月日
                            <div class='block'>
                              <el-date-picker
                                v-model="user.option['dateOfBirth']['text']"
                                type='date'
                                placeholder='Pick a day'
                                @change='dateInput()'
                                value-format='yyyy/MM/dd'>
                              </el-date-picker>
                            </div>
                      </b-list-group-item>
                      <b-list-group-item>団体名
                        <el-input size='medium' type='text' v-model="user.option['organization']['company']"></el-input>
                      </b-list-group-item>
                      <b-list-group-item>部署名
                        <el-input size='medium' type='text' v-model="user.option['organization']['department']"></el-input>
                      </b-list-group-item>
                    </b-list-group>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-list-group-item>
            <b-list-group-item>
              <b-card-body>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('services')}}:</label></b-col>
                  <b-col sm='2'></b-col>
                </b-row>
                <b-row>
                  <b-col sm='2'></b-col>
                  <b-col sm='10'>
                   <b-table
                      :items='services'
                      :fields='fields'>
                      <div slot='icon' class='avatar' slot-scope='item'>
                        <b-img v-if='item.value' :src='item.value' width='32' height='32'></b-img>
                        <!-- <b-img v-else src='../admin.png' width='32' height='32' class='img-avatar'></b-img> -->
                      </div>
                      <div slot='name' slot-scope='item'>
                        <p>{{ item.value }}</p>
                      </div>
                      <div slot='key' slot-scope='item'>
                        <b-form-checkbox :id='item.value' v-model='selectedService[item.value]' @change="changeService()"></b-form-checkbox>
                      </div>
                    </b-table>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-list-group-item>
            <b-list-group-item>
              <b-card-body>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('groups')}}:</label></b-col>
                  <b-col sm='2'></b-col>
                </b-row>
                <b-row>
                  <b-col sm='2'></b-col>
                  <b-col sm='10'>
                   <b-table
                      :items='groups'
                      :fields='fields'>
                      <div slot='icon' class='avatar' slot-scope='item'>
                        <b-img v-if='item.value' :src='item.value' width='32' height='32'></b-img>
                        <!-- <b-img v-else src='../admin.png' width='32' height='32' class='img-avatar'></b-img> -->
                      </div>
                      <div slot='name' slot-scope='item'>
                        <p>{{ item.value }}</p>
                      </div>
                      <div slot='key' slot-scope='item'>
                        <b-form-checkbox :id='item.value' v-model='selectedGroup[item.value]' @change='changeGroup()'></b-form-checkbox>
                      </div>
                    </b-table>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-list-group-item>
            <b-list-group-item>
              <b-card-body>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('enable')}}:</label></b-col>
                  <b-col>
                    <b-form-checkbox id='checkbox3' v-model='user.enable'></b-form-checkbox>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('updatedAt')}}:</label></b-col>
                  <b-col>{{ user.updatedAt * 1000 | moment }}</b-col>
                </b-row>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('createdAt')}}:</label></b-col>
                  <b-col>{{ user.createdAt * 1000 | moment }}</b-col>
                </b-row>
              </b-card-body>
            </b-list-group-item>
            <b-list-group-item v-if='user.key != null'>
              <b-card-body>
                <b-row>
                  <b-col sm='3'><label for='input-none'>ルーティンリファレンス:</label></b-col>
                  <b-col sm='9'>
                    <el-transfer
                      :titles="['未選択', '選択中']"
                      target-order='unshift'
                      filterable
                      :filter-method='filterMethod'
                      filter-placeholder='Keyword'
                      v-model='routineSelected'
                      :data='routineList'>
                    </el-transfer>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-list-group-item>
          </b-list-group>
        </b-card>
        <b-modal ref='errorModal' centered title='Error' class='text-danger' :ok-only='true' ok-variant=danger header-bg-variant=danger>
          <p class='my-4'>{{errorMessage}}</p>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/functions'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      routineList: [],
      routineSelected: [],
      selected: 'user',
      adminOptions: [
        {value: 'admin', text: 'admin'},
        {value: 'owner', text: 'owner'},
        {value: 'coach', text: 'coach'},
        {value: 'user', text: 'user'}
      ],
      ownerOptions: [
        {value: 'owner', text: 'owner'},
        {value: 'coach', text: 'coach'},
        {value: 'user', text: 'user'}
      ],
      fields: {
        icon: {
          label: '',
          class: 'text-center'
        },
        name: {
          label: 'Name',
          class: 'text-center'
        },
        key: {
          label: '',
          class: 'text-center'
        }
      },
      myCroppa: {},
      errorMessage: '',
      file: null,
      uploadedImage: null,
      titles: {
        'owner': 'Created by',
        'role': '権限',
        'name': '名前',
        'email': 'Email',
        'services': '所属サービス',
        'groups': '所属グループ',
        'status': '私のスローガン',
        'icon': 'Icon',
        'routine': 'Routine',
        'enable': '有効',
        'option': '補足情報',
        'updatedAt': '更新日時',
        'createdAt': '作成日時'
      },
      user: null,
      beforeUser: null,
      userSave: null,
      provider: true,
      unwatch: null,
      unsubscribe: null,
      selectedService: {},
      selectedGroup: {},
      isChangeService: false,
      isChangeGroup: false
    }
  },
  beforeDestroy () {
    if (this.unwatch) {
      this.unwatch()
    }
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  },
  created () {
    this.unwatch = this.$store.watch(state => this.$store.getters['user/users'], value => {
      this.init()
    })
    this.init()
  },
  methods: {
    init () {
      const index = this.users.findIndex(user => user.key === this.parameter)
      if (index !== -1) {
        this.user = this.beforeUser = JSON.parse(JSON.stringify(this.users[index]))
        if (!this.user.option['name']) {
          this.user.option = {
            'name': {
              'first': '',
              'first_kana': '',
              'last': '',
              'last_kana': ''
            },
            'dateOfBirth': {
              'int': parseInt(new Date().getTime() / 1000),
              'text': moment(new Date()).format('YYYY/MM/DD')
            },
            'organization': {
              'company': '',
              'department': ''
            }
          }
        }
      } else {
        this.user = {
          'key': this.user.key,
          'role': 'user',
          'services': {},
          'groups': {},
          'name': '',
          'email': '',
          'status': '',
          'icon': '',
          'routine': [],
          'enable': true,
          'option': {
            'name': {
              'first': '',
              'first_kana': '',
              'last': '',
              'last_kana': ''
            },
            'dateOfBirth': {
              'int': parseInt(new Date().getTime() / 1000),
              'text': moment(new Date()).format('YYYY/MM/DD')
            },
            'organization': {
              'company': '',
              'department': ''
            }
          },
          'createdAt': parseInt(new Date().getTime() / 1000),
          'updatedAt': parseInt(new Date().getTime() / 1000)
        }
      }
      var keys = Object.keys(this.user.services)
      for (var i in keys) {
        if (this.user.services[keys[i]]) {
          this.selectedService[keys[i]] = this.user.services[keys[i]]
        }
      }
      keys = Object.keys(this.user.groups)
      for (i in keys) {
        if (this.user.groups[keys[i]]) {
          this.selectedGroup[keys[i]] = this.user.groups[keys[i]]
        }
      }
      this.userSave = JSON.parse(JSON.stringify(this.user))
      this.selected = this.user.role
      this.getRoutineBelongs()
    },
    changeService () {
      this.isChangeService = true
    },
    changeGroup () {
      this.isChangeGroup = true
    },
    dateInput () {
      this.user.option['dateOfBirth']['int'] = parseInt(new Date(this.user.option['dateOfBirth']['text']).getTime() / 1000)
    },
    dateString (date) {
      var objDate = new Date(date)
      return moment(objDate).format('YYYY/MM/DD')
    },
    showModal () {
      this.$refs.errorModal.show()
    },
    hideModal () {
      this.$refs.errorModal.hide()
    },
    generateImage: function () {
      let url = this.myCroppa.generateDataUrl()
      if (!url) {
        this.errorMessage = 'No image selected'
        this.showModal()
        return
      }
      this.user.icon = url
      this.myCroppa.remove()
    },
    goBack () {
      this.$router.go(-1)
    },
    getTitle (item) {
      return this.titles[item]
    },
    onFileSelected (event) {
      this.file = event.target.files[0]
      this.createImage(this.file)
    },
    createImage (file) {
      let reader = new FileReader()
      reader.onload = (e) => {
        this.user.icon = e.target.result
      }
      reader.readAsDataURL(file)
    },
    generateUuid () {
      let chars = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.split('')
      for (let i = 0, len = chars.length; i < len; i++) {
        switch (chars[i]) {
          case 'x':
            chars[i] = Math.floor(Math.random() * 16).toString(16)
            break
          case 'y':
            chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16)
            break
        }
      }
      return chars.join('')
    },
    writeuser () {
      var vm = this
      if (this.user.email === '' || this.user.email === null) {
        return
      }
      var before = JSON.parse(JSON.stringify(this.userSave))
      var tempG = {}
      var tempS = {}
      var keys = Object.keys(this.selectedGroup)
      for (var x in keys) {
        if (this.selectedGroup[keys[x]]) {
          tempG[keys[x]] = true
        }
      }
      keys = Object.keys(this.selectedService)
      for (x in keys) {
        if (this.selectedService[keys[x]]) {
          tempS[keys[x]] = true
        }
      }

      const payload = {
        'key': this.user.key,
        'role': this.user.role,
        'services': tempS,
        'groups': tempG,
        'name': this.user.name,
        'email': this.user.email,
        'status': this.user.status,
        'icon': this.user.icon,
        'routine': this.user.routine,
        'enable': this.user.enable,
        'option': this.user.option,
        'createdAt': this.user.createdAt,
        'updatedAt': parseInt(new Date().getTime() / 1000)
      }

      const db = firebase.firestore()
      const settings = { timestampsInSnapshots: true }
      db.settings(settings)
      const batch = db.batch()
      var refuser = db.collection('users').doc(this.user.key)
      batch.set(refuser, payload)

      if (this.isChangeService) {
        for (var key in payload.services) {
          var index = this.services.findIndex(service => service.key === key)
          if (index !== -1) {
            var chatsRef = this.services[index].chats_ref
          } else {
            continue
          }
          if (payload.services[key] && !before.services[key]) {
            var refChatsRefFrom = db.collection('chats_refs').doc(refuser.id).collection('refs').doc(key)
            batch.set(refChatsRefFrom,
              {
                'location': chatsRef,
                'type': 'service',
                'status': 'accepting',
                'enable': false,
                'createdAt': parseInt(new Date().getTime() / 1000),
                'updatedAt': parseInt(new Date().getTime() / 1000)
              }
            )
            var refChatsRefTo = db.collection('chats_refs').doc(key).collection('refs').doc(refuser.id)
            batch.set(refChatsRefTo,
              {
                'location': chatsRef,
                'type': 'service',
                'status': 'accepting',
                'enable': false,
                'createdAt': parseInt(new Date().getTime() / 1000),
                'updatedAt': parseInt(new Date().getTime() / 1000)
              }
            )
          }
        }
        for (key in before.services) {
          index = this.services.findIndex(service => service.key === key)
          if (index !== -1) {
            chatsRef = this.services[index].chats_ref
          } else {
            continue
          }
          if (!payload.services[key] && before.services[key]) {
            refChatsRefFrom = db.collection('chats_refs').doc(refuser.id).collection('refs').doc(key)
            batch.delete(refChatsRefFrom)

            refChatsRefTo = db.collection('chats_refs').doc(key).collection('refs').doc(refuser.id)
            batch.delete(refChatsRefTo)
          }
        }
      }

      if (this.isChangeGroup) {
        for (key in payload.groups) {
          index = this.groups.findIndex(group => group.key === key)
          if (index !== -1) {
            chatsRef = this.groups[index].chats_ref
          } else {
            continue
          }
          if (payload.groups[key] && !before.groups[key]) {
            refChatsRefFrom = db.collection('chats_refs').doc(refuser.id).collection('refs').doc(key)
            batch.set(refChatsRefFrom,
              {
                'location': chatsRef,
                'type': 'group',
                'status': 'accepting',
                'enable': false,
                'createdAt': parseInt(new Date().getTime() / 1000),
                'updatedAt': parseInt(new Date().getTime() / 1000)
              }
            )
            refChatsRefTo = db.collection('chats_refs').doc(key).collection('refs').doc(refuser.id)
            batch.set(refChatsRefTo,
              {
                'location': chatsRef,
                'type': 'group',
                'status': 'accepting',
                'enable': false,
                'createdAt': parseInt(new Date().getTime() / 1000),
                'updatedAt': parseInt(new Date().getTime() / 1000)
              }
            )
          }
        }
        for (key in before.groups) {
          index = this.groups.findIndex(group => group.key === key)
          if (index !== -1) {
            chatsRef = this.groups[index].chats_ref
          } else {
            continue
          }
          if (!payload.groups[key] && before.groups[key]) {
            refChatsRefFrom = db.collection('chats_refs').doc(refuser.id).collection('refs').doc(key)
            batch.delete(refChatsRefFrom)

            refChatsRefTo = db.collection('chats_refs').doc(key).collection('refs').doc(refuser.id)
            batch.delete(refChatsRefTo)
          }
        }
      }

      batch.commit().then(function () {
        var async = require('async')
        if (vm.isChangeService) {
          vm.isChangeService = false
          var services = JSON.parse(JSON.stringify(vm.services))
          async.each(services, function (service, cb) {
            // if (payload.services[service.key] !== undefined && service.users[refuser.id] !== payload.services[service.key]) {
            if (vm.checkIfModifiedService(payload, service, before)) {
              var refService = db.collection('services').doc(service.key)
              db.runTransaction(function (transaction) {
                return transaction.get(refService).then(function (doc) {
                  if (!doc.exists) {
                    throw new Error('Document does not exist!')
                  }
                  var users = doc.data().users
                  if (payload.services[service.key]) {
                    users[payload.key] = payload.services[service.key]
                  } else {
                    delete users[payload.key]
                  }
                  transaction.update(refService, { users: users })
                  transaction.update(refService, { updatedAt: parseInt(new Date().getTime() / 1000) })
                })
              }).then(function () {
                cb()
                // console.log('Transaction successfully committed!')
              }).catch(function (error) {
                cb()
                console.log('Transaction failed: ', error)
              })
            } else {
              cb()
            }
          }, function (err) {
            if (err) console.log(err)
          })
        }
        if (vm.isChangeGroup) {
          vm.isChangeGroup = false
          var groups = JSON.parse(JSON.stringify(vm.groups))
          async.each(groups, function (group, cb) {
            // if (payload.groups[group.key] !== undefined && group.users[payload.key] !== payload.groups[group.key]) {
            if (vm.checkIfModifiedGroup(payload, group, before)) {
              var refGroup = db.collection('groups').doc(group.key)
              db.runTransaction(function (transaction) {
                return transaction.get(refGroup).then(function (doc) {
                  if (!doc.exists) {
                    throw new Error('Document does not exist!')
                  }
                  var users = doc.data().users
                  if (payload.groups[group.key]) {
                    users[payload.key] = payload.groups[group.key]
                  } else {
                    delete users[payload.key]
                  }
                  transaction.update(refGroup, { users: users })
                  transaction.update(refGroup, { updatedAt: parseInt(new Date().getTime() / 1000) })
                })
              }).then(function () {
                cb()
                // console.log('Transaction successfully committed!')
              }).catch(function (error) {
                cb()
                console.log('Transaction failed: ', error)
              })
            } else {
              cb()
            }
          }, function (err) {
            vm.offLoading()
            if (err) console.log(err)
          })
        } else {
          vm.offLoading()
        }
        // vm.$router.go(-1)
      })
    },
    checkIfModifiedService (payload, service, before) {
      if (payload.services[service.key] !== undefined && !before.services[service.key]) {
        return true
      }
      if (before.services[service.key] !== undefined && !payload.services[service.key]) {
        return true
      }
      return false
    },
    checkIfModifiedGroup (payload, group, before) {
      if (payload.groups[group.key] !== undefined && !before.groups[group.key]) {
        return true
      }
      if (before.groups[group.key] !== undefined && !payload.groups[group.key]) {
        return true
      }
      return false
    },
    disableUser () {
      return new Promise((resolve) => {
        var payload = {
          uid: this.user.key,
          disabled: true
        }
        const disableUser = firebase.functions().httpsCallable('disableUser')
        disableUser(payload).then(function (result) {
          resolve(result)
        })
      })
    },
    storeData () {
      var vm = this
      vm.onLoading()
      if (!this.user.enable) {
        this.disableUser().then(function () {
          vm.user.role = vm.selected
          var routineRef = []
          for (var i = 0; i < vm.routineSelected.length; i++) {
            var routine = vm.routineList[vm.routineSelected[i]]
            routineRef.push(routine.initial)
          }
          vm.user.routine = routineRef
          vm.writeuser()
        })
      } else {
        this.user.role = this.selected
        var routineRef = []
        for (var i = 0; i < this.routineSelected.length; i++) {
          var routine = this.routineList[this.routineSelected[i]]
          routineRef.push(routine.initial)
        }
        this.user.routine = routineRef
        this.writeuser()
      }
    },
    filterMethod (query, item) {
      return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
    },
    getRoutineBelongs () {
      var vm = this
      vm.routineList = []
      vm.routineSelected = []
      Object.keys(vm.routineRefs).forEach(function (key, index) {
        vm.routineList.push({
          label: this[key].title,
          key: index,
          initial: this[key].key
        })
        for (var i = 0; i < vm.user.routine.length; i++) {
          if (vm.user.routine[i].indexOf(this[key].key) >= 0) {
            vm.routineSelected.push(index)
          }
        }
      }, vm.routineRefs)
    }
  },
  computed: {
    ...mapGetters({
      routines: 'routine/routines',
      routineGroups: 'routineGroup/routineGroups',
      routineRefs: 'routineRef/routineRefs',
      services: 'service/services',
      groups: 'group/groups',
      users: 'user/users',
      authUser: 'authUser/user',
      parameter: 'dispatch/user'
    })
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY/MM/DD HH:mm')
    },
    momentShort: function (date) {
      return moment(date).format('YYYY/MM/DD')
    },
    momentMMDD: function (date) {
      return moment(date).format('MM/DD')
    }
  }
}
</script>

<style>
.textTitle {
  white-space: normal;
}
.img {
  max-width: 100%;
  height: auto;
}
.row {
  padding-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/User.vue